/* eslint-disable max-classes-per-file */
import { Uuid } from '@ftr/contracts/type/shared'
import { RealTimePlaybackKey } from '@ftr/data-realtime-playback'
import { UpdateHearingSectionCommand, UpdateSessionJudgesCommand } from './annotations.commands'
import { HearingSectionModel } from './annotations.model'

export class HearingSectionCreatedEvent {
  static readonly type = '[Annotations] Create Hearing Section Event'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly courtSystemId: Uuid,
    readonly id: Uuid,
    readonly triggerSource: 'right-click stt' | 'playback clock' | 'live clock' | 'upcoming hearing',
  ) {}
}

export class HearingSectionDeletedEvent {
  static readonly type = '[Annotations] Delete Hearing Section Event'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly id: Uuid,
    readonly courtSystemId: Uuid,
    readonly source: 'popover' | 'conflict' | 'delete auto-annotation',
    readonly isAutoGenerated: boolean,
  ) {}
}

export class HearingSectionUpdatedEvent {
  static readonly type = '[Annotations] Edit Hearing Section Event'
  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly id: Uuid,
    readonly previousHearingSection: HearingSectionModel,
    readonly updatedHearingSection: HearingSectionModel,
  ) {}
}

export class HearingSectionAcceptedEvent {
  static readonly type = '[Annotations] Accept Auto-Generated Hearing Section Event'
  constructor(readonly hearingSection: HearingSectionModel) {}
}

export class HearingSectionUpdateFailedEvent {
  static readonly type = '[Annotations] Hearing Section Update Failed'

  constructor(
    readonly command: UpdateHearingSectionCommand,
    readonly reason: string,
    readonly isResettable: boolean,
    readonly isRetryable: boolean,
  ) {}
}

export class HearingSectionUpdateSucceededEvent {
  static readonly type = '[Annotations] Hearing Section Update Succeeded'

  constructor(readonly command: UpdateHearingSectionCommand) {}
}

export class SessionJudgeUpdateFailedEvent {
  static readonly type = '[Annotations] Session Judge Update Failed'

  constructor(
    readonly command: UpdateSessionJudgesCommand,
    readonly reason: string,
  ) {}
}

export class SessionJudgeUpdateSucceededEvent {
  static readonly type = '[Annotations] Session Judge Update Succeeded'

  constructor(readonly command: UpdateSessionJudgesCommand) {}
}
